import apiClient from "../api/apiClient"
import { Vendor, CreateVendorForm } from "../../types"

export const vendorService = {
  async getVendors(params?: {
    search?: string
    active_only?: boolean
  }): Promise<Vendor[]> {
    const response = await apiClient.get<Vendor[]>("/admin/vendors", { params })
    return response.data
  },

  async getVendorById(id: string): Promise<Vendor> {
    const response = await apiClient.get<Vendor>(`/admin/vendors/${id}`)
    return response.data
  },

  async createVendor(data: CreateVendorForm): Promise<Vendor> {
    const response = await apiClient.post<{ message: string; vendor: Vendor }>(
      "/admin/vendors",
      data
    )
    return response.data.vendor
  },

  async updateVendor(id: string, data: Partial<CreateVendorForm>): Promise<Vendor> {
    const response = await apiClient.put<{ message: string; vendor: Vendor }>(
      `/admin/vendors/${id}`,
      data
    )
    return response.data.vendor
  },

  async toggleVendorActive(id: string): Promise<Vendor> {
    const response = await apiClient.patch<{ message: string; vendor: Vendor }>(
      `/admin/vendors/${id}/toggle-active`
    )
    return response.data.vendor
  },
}
